import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import { Feather } from "@expo/vector-icons";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
import moment from "moment";
const { width, height } = Dimensions.get("window");

const placeholder = {
  label: "",
  value: null,
  color: "#777777",
};

export default function addbonus({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState({});
  const [weed2, setweed2] = useState({});
  const [weed3, setweed3] = useState({});
  const [weed4, setweed4] = useState({});
  const date = moment().format("YYYY-MM-DD");
  const [state1, setstate1] = useState(moment(date).valueOf());
  const [items, setItems] = useState([]);

  async function getweek1(times) {
    const response = await apiservice({
      path:
        "/freepoint/getdaily/" +
        1 +
        "?month=" +
        moment(times).format("M") +
        "&year=" +
        moment(times).format("YYYY"),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setdata(response.data.data);
    }
  }

  async function getweek2(times) {
    const response = await apiservice({
      path:
        "/freepoint/getdaily/" +
        2 +
        "?month=" +
        moment(times).format("M") +
        "&year=" +
        moment(times).format("YYYY"),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setweed2(response.data.data);
    }
  }

  async function getweek3(times) {
    const response = await apiservice({
      path:
        "/freepoint/getdaily/" +
        3 +
        "?month=" +
        moment(times).format("M") +
        "&year=" +
        moment(times).format("YYYY"),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setweed3(response.data.data);
    }
  }
  async function getweek4(times) {
    const response = await apiservice({
      path:
        "/freepoint/getdaily/" +
        4 +
        "?month=" +
        moment(times).format("M") +
        "&year=" +
        moment(times).format("YYYY"),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setweed4(response.data.data);
    }
  }

  useEffect(() => {
    getweek1(state1);
    getweek2(state1);
    getweek3(state1);
    getweek4(state1);
    setItems([]);
    const nums = ["", "", "", "", "", "", "", "", "", "", "", ""];
    nums.map((e, i) =>
      setItems((val) =>
        val.concat({
          label: moment(date).add(i, "months").format("MMMM YYYY"),
          value: moment(date).add(i, "months").valueOf(),
        })
      )
    );
  }, [focus]);

  const [t, sett] = useState([
    { data },
    { data },
    { data },
    { data },
    { data },
    { data },
    { data },
  ]);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <Text style={styles.textfree}>DAILY BONUS</Text>
          <RNPickerSelect
            placeholder={placeholder}
            onValueChange={(text) => {
              setstate1(parseInt(text));
              getweek1(parseInt(text));
              getweek2(parseInt(text));
              getweek3(parseInt(text));
              getweek4(parseInt(text));
            }}
            value={state1}
            style={{
              inputWeb: {
                width: 70,
                height: 30,
                borderWidth: 1,
                borderColor: "#ccc",
                paddingLeft: 10,
                borderRadius: 5,
                color: "#777777",
                fontFamily: "Prompt-Regular",
                alignSelf: "flex-start",
                alignItems: "center",
                marginVertical: 15,
              },
            }}
            items={items}
          />
          <View style={styles.viewfree}>
            {data == undefined ? (
              <FlatList
                data={t}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <View
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                      </View>
                    </View>
                  );
                }}
              />
            ) : (
              <FlatList
                data={data.reward}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <ImageBackground
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                        source={{
                          uri:

                            item.iamge,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                        <Text
                          style={[
                            styles.textday,
                            {
                              alignSelf: "flex-end",
                              marginTop: 15,
                              marginRight: 5,
                            },
                          ]}
                        >
                          {item.coin}
                        </Text>
                      </ImageBackground>
                    </View>
                  );
                }}
              />
            )}

            <TouchableOpacity
              onPress={() =>
                navigation.navigate("AddDeily", {
                  body: state1,
                  week: 1,
                  weekdata: data,
                })
              }
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ADD</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.textfree}>NEXT</Text>
          <View style={styles.viewfree}>
            {weed2 == undefined ? (
              <FlatList
                data={t}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <View
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                      </View>
                    </View>
                  );
                }}
              />
            ) : (
              <FlatList
                data={weed2.reward}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <ImageBackground
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                        source={{
                          uri:

                            item.iamge,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                        <Text
                          style={[
                            styles.textday,
                            {
                              alignSelf: "flex-end",
                              marginTop: 15,
                              marginRight: 5,
                            },
                          ]}
                        >
                          {item.coin}
                        </Text>
                      </ImageBackground>
                    </View>
                  );
                }}
              />
            )}

            <TouchableOpacity
              onPress={() =>
                navigation.navigate("AddDeily", {
                  body: state1,
                  week: 2,
                  weekdata: weed2,
                })
              }
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ADD</Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.textfree}>NEXT</Text>
          <View style={styles.viewfree}>
            {weed3 == undefined ? (
              <FlatList
                data={t}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <View
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                      </View>
                    </View>
                  );
                }}
              />
            ) : (
              <FlatList
                data={weed3.reward}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <ImageBackground
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                        source={{
                          uri:

                            item.iamge,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                        <Text
                          style={[
                            styles.textday,
                            {
                              alignSelf: "flex-end",
                              marginTop: 15,
                              marginRight: 5,
                            },
                          ]}
                        >
                          {item.coin}
                        </Text>
                      </ImageBackground>
                    </View>
                  );
                }}
              />
            )}

            <TouchableOpacity
              onPress={() =>
                navigation.navigate("AddDeily", {
                  body: state1,
                  week: 3,
                  weekdata: weed3,
                })
              }
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ADD</Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.textfree}>NEXT</Text>
          <View style={styles.viewfree}>
            {weed4 == undefined ? (
              <FlatList
                data={t}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <View
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                      </View>
                    </View>
                  );
                }}
              />
            ) : (
              <FlatList
                data={weed4.reward}
                scrollEnabled={false}
                horizontal
                renderItem={({ index, item }) => {
                  return (
                    <View>
                      <ImageBackground
                        style={{
                          width: index == 6 ? 150 : 60,
                          height: 60,
                          borderRadius: 5,
                          alignSelf: "center",
                          backgroundColor: "#fff",
                          marginRight: 20,
                          borderRadius: 5,
                        }}
                        source={{
                          uri:

                            item.iamge,
                        }}
                      >
                        <Text style={styles.textday}> {index + 1} day </Text>
                        <Text
                          style={[
                            styles.textday,
                            {
                              alignSelf: "flex-end",
                              marginTop: 15,
                              marginRight: 5,
                            },
                          ]}
                        >
                          {item.coin}
                        </Text>
                      </ImageBackground>
                    </View>
                  );
                }}
              />
            )}

            <TouchableOpacity
              onPress={() =>
                navigation.navigate("AddDeily", {
                  body: state1,
                  week: 4,
                  weekdata: weed4,
                })
              }
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ADD</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "100%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
    marginVertical: 10,
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  viewadd: {
    width: 60,
    height: 60,
    borderRadius: 5,
    alignSelf: "center",
    backgroundColor: "#fff",
    marginRight: 20,
  },
  touchadd: {
    width: "10%",
    height: 40,
    backgroundColor: "#DBDBDB",
    justifyContent: "center",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  textday: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
  },
});
